import React, { useMemo, useState } from 'react';
//import { FrameCompaniesTable } from './components/SubContractorsTable';
import { Loading } from '../../../../../../../../components/Loading';
// import { Pagination } from '../../../../../../../../components/Pagination';
import { Margin } from '@ansvar-sakerhet/ui/src/layout/Margin';
import { SubcontractorsTable } from './components/SubcontractorsTable/SubcontractorsTable';
import {
  CompaniesSortControls,
  useGetAllCompanies,
} from '../../../../../../../../traits/api/companies/useGetAllCompanies';
import { SearchInput } from '../../../../../../../../components/SearchInput';

type Props = {
  clientId: string;
};

export const SubContractorsList = ({ clientId }: Props) => {
  const [page] = useState(0);
  const [search, setSearch] = useState('');
  const [sort, setSort] = useState<CompaniesSortControls | undefined>(
    undefined
  );
  const entitiesPerPage = 10;
  const pagination = useMemo(
    () => ({
      skip: entitiesPerPage * page,
      take: entitiesPerPage,
    }),
    [page]
  );

  const { data: companies, isLoading: companiesLoading } = useGetAllCompanies(
    clientId,
    pagination.take,
    pagination.skip,
    search,
    sort
  );

  return (
    <>
      <SearchInput
        input={search}
        setInput={setSearch}
        placeholder="Sök efter bolag"
      />
      <Margin $top="m" />
      {companiesLoading || !companies ? (
        <Loading />
      ) : (
        <SubcontractorsTable
          companies={companies}
          clientId={clientId}
          sort={sort}
          setSort={setSort}
        />
      )}
      <Margin $top="m" />
      {/* <Pagination
        numberOfPages={Math.ceil(count / entitiesPerPage)}
        page={page}
        setPage={setPage}
      /> */}
    </>
  );
};
